import { EGroupedItemsType } from '~/src/services/properties';
import { analytics } from './Part/analyticsPartConfig';

export const installmentPlanFormConfig = {
    label: {
        name: 'label',
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            displayPrice: {
                name: 'displayPrice',
                order: 0,
                label: 'Отображать цены',
                type: EGroupedItemsType.Boolean,
            },
            customize: {
                name: 'customize',
                label: 'Настройки формы',
                order: 1,
                items: {
                    globalEnsId: {
                        name: 'globalEnsId',
                        order: 1,
                        label: 'GlobalId',
                        type: EGroupedItemsType.String,
                    },
                    productId: {
                        name: 'productId',
                        order: 2,
                        label: 'ProductId',
                        type: EGroupedItemsType.Select,
                    },
                },
            },
            namePlaceholder: {
                name: 'namePlaceholder',
                order: 2,
                label: 'Плейсхолдер имени',
                type: EGroupedItemsType.String,
            },
            phonePlaceholder: {
                name: 'phonePlaceholder',
                order: 3,
                label: 'Плейсхолдер телефона',
                type: EGroupedItemsType.String,
            },
            buttonText: {
                name: 'buttonText',
                order: 4,
                label: 'Текст кнопки',
                type: EGroupedItemsType.String,
            },
            buttonBackgroundColor: {
                name: 'buttonBackgroundColor',
                label: 'Цвет кнопки:',
                type: EGroupedItemsType.ColorPicker,
            },
            buttonBackgroundHoverColor: {
                name: 'buttonBackgroundHoverColor',
                label: 'Цвет кнопки при наведении:',
                type: EGroupedItemsType.ColorPicker,
            },
            buttonTextColor: {
                name: 'buttonTextColor',
                label: 'Цвет текста кнопки:',
                type: EGroupedItemsType.ColorPicker,
            },
            popupTitleSuccess: {
                name: 'popupTitleSuccess',
                order: 5,
                label: 'Заголовок успеха',
                type: EGroupedItemsType.String,
            },
            popupTitleError: {
                name: 'popupTitleError',
                order: 6,
                label: 'Заголовок ошибки',
                type: EGroupedItemsType.String,
            },
            customStyles: {
                name: 'customStyles',
                order: 10,
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                withBreakpoints: true,
            },
            checkboxProperties: {
                name: 'customize',
                label: 'Настройки чек-бокса',
                order: 1,
                items: {
                    font: {
                        name: 'font',
                        label: 'Шрифт',
                        type: EGroupedItemsType.Select,
                    },
                    color: {
                        name: 'color',
                        label: 'Цвет:',
                        type: EGroupedItemsType.ColorPicker,
                    },
                },
            },
            analytics: { ...analytics },
        },
    },
};
